// extracted by mini-css-extract-plugin
export default {"container":"fI_M","inline":"_1P12"};